import $ from "jquery";
import React from 'react';
import { Button } from 'semantic-ui-react';
import TextField from '@material-ui/core/TextField';


import Title from '../../title';
import AddEdit from './AddEdit';
import Loading from '../../loading';
import CompletedJob from './CompletedJob';
import InCompletedJob from './InCompletedJob';
import Server from '../../../functions/server';
import ReadCookie from '../../../functions/readcookies';
import Permission from '../../../functions/permission';
import getFormatedDate from '../../../functions/date';




export default class App extends React.Component {

    state = {
        laborList: [],
        fromDate: getFormatedDate(new Date(), 7),
        toDate: getFormatedDate(new Date()),
    }

    componentDidMount() {
        this.getLabor();
    }

    getLabor = () => {
        let context = this;
        context.setState({ load: true, message: 'Getting Labor Details', })
        let { fromDate, toDate } = this.state;
        $.ajax({
            type: 'POST', data: { fromDate, toDate }, 
            url: Server() + 'AdminControl/Labor/get.php',
            success: function (laborList) {
                console.log(laborList);
                try {
                    laborList = JSON.parse(laborList);
                    context.setState({ laborList, load: false })
                } catch (error) {
                    context.setState({ load: false })
                    alert('Error1')
                }
            },
            error: function (e) {
                alert('Try again1!!')
                context.setState({ load: false });
            }
        });
    }

    render() {
        let { load, message, laborList } = this.state;
        let i = 0;
        return (
            <div>
                <Title title={'Mechanic'} openDrawer={this.props.openDrawer} menus={this.props.menus} />
                <Loading load={load} message={message} />
                <div style={{margin: '0.5%'}}>
                    
                    <div style={{display: 'flex'}}>
                        <div  style={{marginLeft: '0.5%'}}>
                            <TextField label="From" type="date"
                                onChange={(e) => this.setState({fromDate: e.target.value})}
                                defaultValue={this.state.fromDate} />
                        </div>
                        <div  style={{marginLeft: '0.5%'}}>
                            <TextField label="To" type="date"
                                onChange={(e) => this.setState({toDate: e.target.value})}
                                defaultValue={this.state.toDate} />
                        </div>
                        <div style={{marginLeft: '0.5%', marginTop: '0.5%'}}>
                            <Button onClick={ () => this.getLabor()}>Submit</Button>
                        </div>
                        <div style={{marginTop: '0.5%', marginBottom: '0.5%'}}><AddEdit refresh={this.getLabor} /></div>
                    </div>
                    <table id='table' width='100%'>
                        <tr>
                            <th id='th'><center>Sino</center></th>
                            <th id='th'><center>Name</center></th>
                            <th id='th'><center>Mobile</center></th>
                            <th id='th'><center>Alt. Mobile</center></th>
                            <th id='th'><center>Email</center></th>
                            <th id='th'><center>Status</center></th>
                            <th id='th'><center>Earning</center></th>
                            <th id='th'><center>Job Completed</center></th>
                            <th id='th'><center>Job InCompleted</center></th>
                            <th id='th'><center>Active</center></th>
                        </tr>
                        {
                            laborList.map((c) => {
                                return (
                                    <tr>
                                        <td>{++i}</td>
                                        <td>{c.name}</td>
                                        <td>{c.mobile}</td>
                                        <td>{c.altmobile}</td>
                                        <td>{c.email}</td>
                                        <td>{c.status}</td>
                                        <td>{c.earnings}</td>
                                        <td><center><CompletedJob count={c.completed} item={c} /></center></td>
                                        <td><center><InCompletedJob count={c.incompleted} item={c} /></center></td>
                                        <td><center><AddEdit item={c} refresh={this.getLabor} /></center></td>
                                    </tr>
                                )
                            })
                        }
                    </table>
                </div>
            </div>
        );
    }

}